import { Typography, type TypographyProps } from '@mui/material';
import clsx from 'clsx';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

//#region : Main component

/** Custom. Main component parameters type */
export interface PageHeadingProps extends TypographyProps {
    center?: boolean;
    isSubHeading?: boolean;
}

/**
 * Custom helper component.
 *
 * Use it to declare page's main heading and sub heading.
 *
 * Main heading will be h1 and subheading will be h4.
 */
export default function PageHeading({ center, isSubHeading, children, className, ...rest }: PageHeadingProps) {
    return (
        <Typography
            className={twMerge(
                clsx({
                    'text-center': center,
                    'mb-[24px] font-normal text-[#444444] dark:text-[#B6B6B6]': isSubHeading,
                }),
                className
            )}
            variant={isSubHeading ? 'h4' : 'h1'}
            {...rest}
        >
            {children}
        </Typography>
    );
}
//#endregion : Main component
